import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  TwoFactorConfirmResponse,
  TwoFactorRecoveryCodesResponse,
  TwoFactorSetupResponse,
  TwoFactorSimpleResponse,
  TwoFactorStatus,
} from '../models/auth.models';
import { TwoFactorStore } from '../state/two-factor.store';

@Injectable({ providedIn: 'root' })
export class TwoFactorService {
  private readonly http = inject(HttpClient);
  private readonly store = inject(TwoFactorStore);
  private readonly base = `${environment.restApiUrl}/autho/2fa`;
  private readonly jsonOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  getStatus(): Observable<TwoFactorStatus> {
    return this.http
      .get<TwoFactorStatus>(`${this.base}/status/`, this.jsonOptions)
      .pipe(tap((status) => this.store.setStatus(status)));
  }

  setup(): Observable<TwoFactorSetupResponse> {
    return this.http.post<TwoFactorSetupResponse>(`${this.base}/setup/`, null, this.jsonOptions);
  }

  confirm(code: string): Observable<TwoFactorConfirmResponse> {
    return this.http
      .post<TwoFactorConfirmResponse>(`${this.base}/confirm/`, { code }, this.jsonOptions)
      .pipe(tap(() => this.refreshStatus()));
  }

  disable(password: string): Observable<TwoFactorSimpleResponse> {
    return this.http
      .post<TwoFactorSimpleResponse>(`${this.base}/disable/`, { password }, this.jsonOptions)
      .pipe(tap(() => this.refreshStatus()));
  }

  regenerateRecoveryCodes(password: string): Observable<TwoFactorRecoveryCodesResponse> {
    return this.http
      .post<TwoFactorRecoveryCodesResponse>(`${this.base}/recovery-codes/`, { password }, this.jsonOptions)
      .pipe(tap(() => this.refreshStatus()));
  }

  private refreshStatus(): void {
    this.getStatus().subscribe({ error: () => void 0 });
  }
}
